import { useCallback } from 'react';
import { useThemeChoice, useThemeName } from '../kit/hooks';
import { THEMES, setTheme, toggleTheme, type ThemeChoice, type ThemeName } from '../kit/theme';

export type { ThemeChoice, ThemeName };

/** Theme choice persisted in localStorage; "system" follows prefers-color-scheme. */
export function useTheme() {
  const choice = useThemeChoice();
  const effective = useThemeName();
  const setChoice = useCallback((next: ThemeChoice, origin?: { x: number; y: number }) => void setTheme(next, origin), []);
  const toggle = useCallback((origin?: { x: number; y: number }) => void toggleTheme(origin), []);
  return { choice, effective, dark: effective === THEMES.dark, setChoice, toggle };
}
